import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@material-ui/core/styles";
import { Grid, Typography, MenuItem, useMediaQuery } from "@material-ui/core";
import OtaCsvUpload from "../OtaCsvUpload";
import { FilledSelect, FilledTextField } from "../../../components/FormElements";
import QrCodeScanner from "../../Fleet/QrCodeScanner";

const VehicleSearch = ({
  searchById,
  searchText,
  handleSearchByChange,
  handleSearchTextChange,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showQr, setShowQr] = useState(false);
  const [showCsvUploadModal, setShowCsvUploadModal] = useState(false);

  const handleQrScan = (text) => {
    if (!text) return;
    let shortCode;
    // handles different short code versions
    // spmn.io shorcode
    if (text.length > 16) {
      shortCode = text.slice(16);
    } else {
      // b'U1A shorcode
      shortCode = text.slice(7);
    }
    if (!searchById && searchText.length > 0) {
      shortCode = `${searchText},${shortCode}`;
    }

    handleSearchTextChange({ shortcodes__shortcode__in: shortCode });
    setShowQr(false);
  };

  const handleCsvFileText = async (text) => {
    if (!text) return;
    let shortCode;
    if (!searchById && searchText.length > 0) {
      shortCode = `${searchText},${text}`;
    } else shortCode = text;

    handleSearchTextChange({ shortcodes__shortcode__in: shortCode });
    setShowCsvUploadModal(false);
  };

  return (
    <Grid container item xs={12}>
      <Grid item xs={12} style={{ marginTop: theme.spacing(2) }}>
        <Typography variant="h6" style={{ fontSize: "16px" }}>
          Vehicles
        </Typography>
      </Grid>
      <Grid container item spacing={2} xs={12}>
        <Grid item xs={12} md={3}>
          <FilledSelect
            label="Filter by"
            FormControlProps={{ fullWidth: true, margin: "normal" }}
            onChange={(e) => handleSearchByChange(e.target.value)}
            value={searchById ? "vehicle_id" : "vehicle_shortcode"}
          >
            <MenuItem value="vehicle_id">Vehicle ID</MenuItem>
            <MenuItem value="vehicle_shortcode">Vehicle Shortcode</MenuItem>
          </FilledSelect>
        </Grid>
        <Grid item xs={12} md={9}>
          <FilledTextField
            value={searchText}
            underlineColor={theme.palette.text.lightgrey}
            label="Comma Separated Values"
            fullWidth
            // eslint-disable-next-line no-nested-ternary
            type={isMobile ? "qr-scan" : !searchById ? "csv-upload" : ""}
            multiline
            onChange={(e) => {
              handleSearchTextChange({
                [searchById ? "ids__in" : "shortcodes__shortcode__in"]: e.target.value,
              });
            }}
            onIconClick={() => (isMobile ? setShowQr(true) : setShowCsvUploadModal(true))}
          />
          <QrCodeScanner
            isOpen={showQr}
            onClose={() => setShowQr(false)}
            onScan={handleQrScan}
            partType="shortCode"
          />
          <OtaCsvUpload
            isOpen={showCsvUploadModal}
            onUpload={(e) => handleCsvFileText(e)}
            onClose={() => setShowCsvUploadModal(false)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

VehicleSearch.propTypes = {
  searchById: PropTypes.bool.isRequired,
  searchText: PropTypes.string,
  handleSearchByChange: PropTypes.func.isRequired,
  handleSearchTextChange: PropTypes.func.isRequired,
};

VehicleSearch.defaultProps = {
  searchText: "",
};

export default VehicleSearch;
